const DEFAULT_MAX_ZOOM = 21;

const isValidLatitude = (value) => Number.isFinite(value) && value >= -90 && value <= 90;
const isValidLongitude = (value) => Number.isFinite(value) && value >= -180 && value <= 180;
const isValidZoom = (value, maxZoom) => (
  Number.isFinite(value) && value >= 0 && value <= maxZoom
);

export const readMapViewportFromSearch = (
  search,
  { maxZoom = DEFAULT_MAX_ZOOM } = {}
) => {
  const params = new URLSearchParams(search);

  if (!params.has('lat') || !params.has('lng') || !params.has('z')) {
    return null;
  }

  const lat = Number(params.get('lat'));
  const lng = Number(params.get('lng'));
  const zoom = Number(params.get('z'));

  if (
    !isValidLatitude(lat)
    || !isValidLongitude(lng)
    || !isValidZoom(zoom, maxZoom)
  ) {
    return null;
  }

  return {
    center: { lat, lng },
    zoom,
  };
};

export const formatMapViewportForUrl = ({ lat, lng, zoom }) => ({
  lat: lat.toFixed(6),
  lng: lng.toFixed(6),
  z: String(Number(zoom.toFixed(2))),
});
